/**
 * Chatbot products bootstrap.
 * Core implementation lives in `chatbot-products-core.js`.
 */
(function () {
  'use strict';

  if (!window.ChatbotProductsCore || typeof window.ChatbotProductsCore.init !== 'function') {
    console.error('ChatbotProductsCore is not loaded.');
      return;
    }

  window.ChatbotProducts = window.ChatbotProductsCore.init();

  document.addEventListener('cart:refresh', function () {
    if (window.ChatbotProducts && window.ChatbotProducts.syncStorefrontCartCount) {
        window.ChatbotProducts.syncStorefrontCartCount();
    }
});

  document.addEventListener('cart:updated', function () {
    if (window.ChatbotProducts && window.ChatbotProducts.syncStorefrontCartCount) {
        window.ChatbotProducts.syncStorefrontCartCount();
    }
});
})();